<nav>
  <ul class="pagination">
    <li class="page-item">
      <a class="page-link" (click)="goToPage(1)" *ngIf="showPreviousPage">
        Первая
      </a>
    </li>
    <li>
      <a class="page-link" *ngIf="currentPage > 4">
        ...
      </a>
    </li>
    <li class="page-item" *ngFor="let page of firstPart">
      <a class="page-link" (click)="goToPage(page)">
        {{ page }}
      </a>
    </li>
    <li class="page-item" class="active">
      <a class="page-link">
        {{ currentPage }}
      </a>
    </li>
    <li class="page-item" *ngFor="let page of lastPart">
        <a class="page-link" (click)="goToPage(page)">
          {{ page }}
        </a>
      </li>
    <li>
      <a class="page-link" *ngIf="currentPage < totalPages - 3">
        ...
      </a>
    </li>

    <li class="page-item">
      <a class="page-link" (click)="goToPage(totalPages)" *ngIf="showNextPage">
        Последняя
      </a>
    </li>
  </ul>
</nav>
      